import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap, take } from 'rxjs/operators';
import { InfoTableConfig, InfoTableConfigService } from '@capturum/ui/info-table';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { AuthService } from '@core/services/auth.service';

@Component({
    selector: 'app-basic-layout',
    templateUrl: './basic-layout.component.html',
    styleUrls: ['./basic-layout.component.scss'],
    standalone: false
})
export class BasicLayoutComponent {
  public showNavbar = false;
  public isInstallerSuspended = false;

  public isVisible = true;
  public lastScrollTop = 0;

  @HostListener('window:scroll', [])
  private onWindowScroll(): void {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > this.lastScrollTop && currentScroll > 50) {
      this.isVisible = false;
    } else if (currentScroll < this.lastScrollTop) {
      this.isVisible = true;
    }

    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private translateService: TranslateService,
    private infoTableConfigService: InfoTableConfigService,
    private readonly primeNgConfig: PrimeNG,
    private readonly authService: AuthService
  ) {
    this.isInstallerSuspended = this.authService.getUser()?.installer_suspended;
    this.primeNgConfig.setTranslation({
      clear: this.translateService.instant('calendar-locale.clear'),
    });

    this.translateService.onLangChange.subscribe(({ translations }) => {
      this.primeNgConfig.setTranslation({
        clear: translations['calendar-locale.clear'],
      });
    });

    this.router.events
      .pipe(
        filter((event) => {
          return event instanceof NavigationEnd;
        }),
        map(() => {
          return this.activatedRoute;
        }),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }

          return route;
        }),
        filter((route) => {
          return route.outlet === 'primary';
        }),
        mergeMap((route) => {
          return route.data;
        })
      )
      .subscribe((event) => {
        this.showNavbar = event?.showNavbar ?? false;
      });

    this.infoTableConfigService
      .getConfig()
      .pipe(filter(Boolean), take(1))
      .subscribe((config: InfoTableConfig) => {
        this.infoTableConfigService.setConfig({
          ...config,
          defaultTexts: {
            ...config.defaultTexts,
            noResults: this.translateService.instant('LeadPortal.list.no-result'),
          },
        });
      });
  }
}
